import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=1485c931&scoped=true"
import script from "./MyDetails.vue?vue&type=script&lang=js"
export * from "./MyDetails.vue?vue&type=script&lang=js"
import style0 from "./MyDetails.vue?vue&type=style&index=0&id=1485c931&prod&scoped=true&lang=scss"
import style1 from "./MyDetails.vue?vue&type=style&index=1&id=1485c931&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485c931",
  null
  
)

export default component.exports